import { createContext } from 'react';
import initialDataIntegrationState from './initialDataIntegrationState';

const DataIntegrationContext = createContext(initialDataIntegrationState);

export default DataIntegrationContext;
